import { createSlice } from '@reduxjs/toolkit'
import { REHYDRATE } from 'redux-persist'
import { DEFAULT_FEATURES } from 'constants/features.constant'

export const initialState = {
    loaded: false,
    value: DEFAULT_FEATURES,
}

export const featuresSlice = createSlice({
    name: 'settings/features',
    initialState,
    reducers: {
        setFeatures: (state, action) => {
            state.value = { ...DEFAULT_FEATURES, ...(action.payload || {}) }
            state.loaded = true
        },
    },
    extraReducers: (builder) => {
        // Same reasoning as nameSlice: paint from the cached flags, but force
        // a revalidation against the server on every load.
        builder.addCase(REHYDRATE, (state) => {
            state.loaded = false
        })
    },
})

export const { setFeatures } = featuresSlice.actions

export default featuresSlice.reducer
